import { Dialog as BaseDialog } from '@base-ui/react/dialog';
import { FC } from 'react';

import CloseIcon from '@/assets/svg/ui-elements/close.svg';
import DownloadIcon from '@/assets/svg/ui-elements/download.svg';

import Typography from '../Typography';
import {
  Actions,
  ControlButton,
  ControlLink,
  FullImage,
  HeaderBar,
  StyledBackdrop,
  StyledPopup,
} from './Lightbox.styled';
import { LightboxProps } from './types';

const Lightbox: FC<LightboxProps> = ({ open, onClose, src, alt, downloadUrl, downloadName }) => (
  <BaseDialog.Root
    open={open}
    onOpenChange={(nextOpen) => {
      if (!nextOpen) onClose();
    }}
    modal
  >
    <BaseDialog.Portal>
      <StyledBackdrop />
      <BaseDialog.Viewport>
        <StyledPopup>
          <HeaderBar>
            <BaseDialog.Title
              render={<Typography variant="body2" fontWeight={500} as="h2" noWrap />}
            >
              {alt}
            </BaseDialog.Title>
            <Actions>
              {downloadUrl && (
                <ControlLink
                  href={downloadUrl}
                  download={downloadName ?? alt}
                  aria-label={`Download ${downloadName ?? alt}`}
                >
                  <DownloadIcon aria-hidden="true" />
                </ControlLink>
              )}
              <BaseDialog.Close render={<ControlButton aria-label="Close" />}>
                <CloseIcon aria-hidden="true" />
              </BaseDialog.Close>
            </Actions>
          </HeaderBar>
          <FullImage src={src} alt={alt} />
        </StyledPopup>
      </BaseDialog.Viewport>
    </BaseDialog.Portal>
  </BaseDialog.Root>
);

Lightbox.displayName = 'Lightbox';

export default Lightbox;
